import React, { useEffect, useState } from "react";
import { supabase } from "../Services/supabaseClient";
import { useCompany } from "../context/CompanyContext";
import "../Product/customers.css";

export default function InventoryValuationReport() {
  const { companyId } = useCompany();
  const [rows, setRows] = useState([]);

  useEffect(() => {
    (async () => {
      if (!companyId) return;
      const { data } = await supabase
        .from("inventory_valuation_report")
        .select("*")
        .eq("company_id", companyId)
        .order("method", { ascending: true });
      setRows(data || []);
    })();
  }, [companyId]);

  return (
    <div className="customers-container">
      <header className="cust-head panel">
        <div style={{ fontWeight: 900 }}>Inventory Valuation (FIFO/WAC)</div>
      </header>

      <section className="panel table-panel">
        <div className="table-wrap">
          <table className="customer-table">
            <thead>
              <tr>
                <th>Method</th>
                <th>Warehouse</th>
                <th>SKU</th>
                <th>Item</th>
                <th className="num">Qty</th>
                <th className="num">Avg cost</th>
                <th className="num">Value</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={`${r.method}-${r.warehouse_id}-${r.item_id}-${i}`}>
                  <td>
                    <span className="chip">{r.method}</span>
                  </td>
                  <td>{r.warehouse_name || "—"}</td>
                  <td>{r.sku}</td>
                  <td>{r.item_name}</td>
                  <td className="num">{Number(r.qty_on_hand || 0)}</td>
                  <td className="num">
                    {r.avg_cost == null
                      ? "—"
                      : Number(r.avg_cost).toLocaleString()}
                  </td>
                  <td className="num">
                    ₦{Number(r.value || 0).toLocaleString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {!rows.length && (
            <div className="empty-state">
              <p>No valuation rows.</p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
